// extracted by mini-css-extract-plugin
module.exports = {"menu":"AppMenu_menu__QkC-y","link":"AppMenu_link__3cMRS","navItem":"AppMenu_navItem__1v1bf","menuActive":"AppMenu_menuActive__1pzAU"};